import "core-js/modules/es.function.name.js";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import { DropdownOptionWrapper, OptionName } from "./styles";
export var DropdownOption = function DropdownOption(props) {
  var handleClick = function handleClick() {
    var _props$onSelect;
    (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, props.option);
  };
  return /*#__PURE__*/React.createElement(DropdownOptionWrapper, {
    selected: props.selected,
    key: props.option.customerBrandOrderToken,
    onClick: handleClick
  }, props.option.date ? ( /*#__PURE__*/React.createElement(Column, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Typography, null, props.option.date))) : null, /*#__PURE__*/React.createElement(OptionName, null, props.option.name), /*#__PURE__*/React.createElement(Spacer, {
    size: 12
  }), props.option.customerBrandOrderToken ? ( /*#__PURE__*/React.createElement(Column, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued,
    align: "right"
  }, props.option.customerBrandOrderToken))) : null);
};